import { ChakraBox as Box, Collapsible as RuicCollapsible } from "@airhelp/react-ui-components";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import type { CollapsibleProps } from "./Collapsible.d";

const collapsibleContentStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  heading: { ...contentStyles.heading, mt: { base: 2, md: 8 }, mb: { base: 4, md: 6 } },
  paragraph: { ...contentStyles.paragraph, fontSize: "md" },
};

export const Collapsible = ({
  collapsibleItems = [],
  variant = "primary",
  isChat = false,
  heading,
}: CollapsibleProps) => (
  <Box maxW="832px" px={4} mx="auto" textAlign={{ base: "left", md: "center" }}>
    {!isEmpty(heading) && <RichtextAdapter content={heading} customStyles={collapsibleContentStyles} />}
    {collapsibleItems.map((item) => (
      <RuicCollapsible key={item._uid} title={item.title} variant={variant} isChat={isChat} mb={4} textAlign="left">
        <RichtextAdapter content={item.content} customStyles={collapsibleContentStyles} />
      </RuicCollapsible>
    ))}
  </Box>
);
